import { useState, useEffect } from 'react';
import axios from 'axios';
import { base_url } from '../baseUrl';

const useItemsDB = (perPage = 200) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchItems = async () => {
      setLoading(true);
      setError(null);

      try {
        const { data } = await axios.get(`${base_url}api/items`);
        
        // Map API response to match the expected structure
        const mappedItems = (data.items || []).map((item) => {
          return {
            item_id: item.item_id || '', // Use Zoho Item ID for cart
            name: item.item_name || '',
            rate: parseFloat(item.rate || 0),
            stock_on_hand: item.stock_on_hand || 0,
            category_name: item.category_name || '',
            unit: item.unit || '',
            status: item.status || '',
          };
        });

        setItems(mappedItems);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchItems();
  }, [perPage]);

  return { items, loading, error };
};

export default useItemsDB;
